import React, {Component} from 'react';
import {observer, inject} from "mobx-react";
import Moment from 'react-moment'
import { Link } from 'react-router-dom';


class LastComboBlock extends Component {
  getRoot(comment) {
    return this.props.list.root_elements[comment.category_id][comment.element_id];
  }
  getRootName(comment) {
    const root=this.getRoot(comment);
    if(root) {
      return root.name || "Фото";
    }
    return "Удалено";
  }
  renderAttachments(comment) {
    if(comment.attachments && comment.attachments.length>0) {
      return (
        <div>
          {comment.attachments.map((item,index)=>{
            if(item.type == "gallery" || item.type == "image") {
              return <span className="dib sc1 mdi mdi-image-multiple fs20 op50"></span>;
            }
            if(item.type == "tenorgif") {
              return <span className="dib sc1 mdi mdi-gif fs20 op50"></span>;
            }
            if(item.type == "myphotos") {
              return <span className="dib sc1 mdi mdi-image-area-close fs20 op50"></span>;
            }
            if(item.type == "embed") {
              return <span className="dib sc1 mdi mdi-iframe-outline fs20 op50"></span>;
            }
          })}
        </div>
      )
    }
    return null;
  }
  makeUrl(to, child, props={}) {
    if(this.props.standalone) {
      return <a href={to} {...props}>{child}</a>
    } else {
      return <Link to={to} {...props}>{child}</Link>
    }
  }
  getDetailUrl(comment) {
    const root=this.getRoot(comment);
    if(root) {
      return root.detail_url + `?comment=${comment._id}`;
    }
    return false;
  }
  render() {
    return (
      <div>
        {this.props.list.items.map((comment, index)=>{
          return (
            <div key={comment._id} className="bg-w1 solid1 bo-w2 rad4 mbottom4 vpadd5 pr hov">
              <div className="hpadd10 pbottom2 pr">
                {this.makeUrl(`/shelf/${comment.user.nick}`,comment.user.nick, { className:"fs13 pr z3" })}
                <div className="pa pa-tr mdi mdi-arrow-right op-hov pright5 trans03 arrowPull"></div>
              </div>
              <div className="fs13 hpadd10">
                {comment.small_text}
                {this.renderAttachments(comment)}
              </div>
              <div className="ptop5 fs10 w5 hpadd10">
                <div className="up12 margin">
                  <div className="cell s-5 hellip wsnw ofh">
                    {this.getRootName(comment)}
                  </div>
                  <div className="cell s-7 tar">
                    <Moment locale={this.props.translateStore.t.locale} format={'LLL'}>{comment.time_str}</Moment>
                  </div>
                </div>
              </div>
              {this.getDetailUrl(comment)?this.makeUrl(this.getDetailUrl(comment),'',{ className:"pa pa-tl w100 h100 db z2" }):null}
            </div>
          )
        })}
      </div>
    )
  }
}

export default inject("translateStore")(observer(LastComboBlock));